/**
 *
 * @param {Number} grade
 * @returns {string} a grade with two decimals localized for pt-BR
 */
export const printMockExamGrade = (grade) => {
  if (!grade) {
    return '-'
  }

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(grade)
}

export const formatPercentage = (value) => {
  if (value == null || value === undefined) return '-'

  const numValue = typeof value === 'string' ? parseFloat(value) : value

  if (isNaN(numValue)) return '-'

  return new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(numValue / 100)
}
